import { Link } from 'react-router';
import { OffersMigrationAlert } from '@client/new/components/OffersMigrationAlert';
import { Typography } from '@design-system/components/typography/typography';
import * as styles from '@client/new/components/OffersMigrationAlert.css';

type MigrationInfoBoxProps = {
  visible: boolean;
  offersDashboardTo: string;
};

export const MigrationInfoBox = ({
  visible,
  offersDashboardTo,
}: MigrationInfoBoxProps) => (
  <OffersMigrationAlert
    visible={visible}
    dismissKey="homeMigrationInfoBoxDismissed"
    body={
      <Typography
        variant="body"
        size="medium"
        fontWeight="normal"
        color="N-100"
      >
        Your existing links and landing pages will still work, no need to change
        anything. You can grab new ones from your{' '}
        <Link to={offersDashboardTo} className={styles.inlineLink}>
          Offers dashboard
        </Link>{' '}
        from now on.
      </Typography>
    }
  />
);
